<template>
<v-content>
    <v-row>
        <v-col cols="6">
            <v-btn outlined class="ma-2 white--text" color="primary" @click="uploadData">
                <v-icon left dark>mdi-plus</v-icon>
                Processar Informações
            </v-btn>
        </v-col>
        <v-col cols="6">
            <v-select :items="item" :key="key"/>
            <v-btn outlined class="ma-2 white--text" color="primary" @click="readData">
                <v-icon left dark>mdi-plus</v-icon>
                Ler Informações
            </v-btn>              
        </v-col>
    </v-row>
    <v-row>
        
    </v-row>
</v-content>
</template>
<script>
import {db} from '@/main'

export default {
    data(){
        return{
            database : {
               message: {
                   'text':'Teste de texto da mensagem !@#ção',
                   'subject':'Teste de Assunto da mensagem !!@#ção',
                   'html':'Teste de <code>HTML DA MENSAGEM</code>',
               },
               to: ['lincoln19922@gmail.com']
            },
            item: '',
            key: 0
        }
    },
    methods:{
        uploadData(){
            db.collection('messageSend').add(this.database).then(async() => {
                console.log('Sucesso')
            }).catch(function (error) { 
                console.error('Error to Save Config - AttendPage: ' + error)
            }) 
        },
        readData(){
            db.collection('segmentos').orderBy('nome').get()
            .then((seg) => {                           
                this.item = seg.docs.map(doc => {let a = doc.data(); a.id = doc.id; return a.nome});
                this.key += 1
                console.log('users',this.item)                
            }).catch(function (error) {
                console.error("Error get users: ", error);
            });            
        }
    }
}
</script>